import { useState } from "react";

import { useAppDispatch } from "@js/hooks";

import { clickClientInviteAgreeTerms } from "../../actions";
import { useNewClientSignUpInvitation } from "../new-client-signup-invitation";

/**
 * Used to track if a new client agreed to terms and conditions.
 *
 * Ensures the event is logged only once, even if the user toggles the TOS checkbox multiple times.
 *
 * Handles the following tracking events:
 * - CLICK_CLIENT_SIGNUP_AGREE_TERMS
 * - CLICK_CLIENT_INVITE_SIGNUP_AGREE_TERMS
 */

export const useTrackClientSignUpTermsClicked = () => {
  const { isClientInvitation } = useNewClientSignUpInvitation();
  const [termsClicked, setTermsClicked] = useState(false);
  const dispatch = useAppDispatch();

  const handleTermsClick = () => {
    if (termsClicked) return;

    if (isClientInvitation) {
      dispatch(clickClientInviteAgreeTerms());
    }
    setTermsClicked(true);
  };

  return { handleTermsClick };
};
